import { render, staticRenderFns } from "./ProspectForm.vue?vue&type=template&id=4d0afa0a"
import script from "./ProspectForm.vue?vue&type=script&lang=ts"
export * from "./ProspectForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports